<template>
    <div class="md-detail-info standard" :style="{ marginBottom }">
        <DetailBanner
            :listingDetail="listingDetail"
            :apptTitle="apptTitle"
            :apptSubTitle="apptSubTitle"
            :apptSubmitText="apptSubmitText"
            :apptQuestionMsg="apptQuestionMsg"
            @showFixedBannerChange="showFixedBannerChange"
        />
        <module-box ref="detailInfo">
            <div
                class="extral-banner-left"
                v-if="prevAndNext.show && !showFixedBanner && !isMobileSize"
            >
                <template v-if="prevAndNext.canPrev">
                    <a
                        class="btn"
                        :href="prevAndNext.prevHref || null"
                        self="true"
                        rel="noopener noreferrer"
                    >
                        <span class="iconfont icon-next-big prev"></span>
                        <span class="text">{{
                            $t('md-detail-info.prev')
                        }}</span>
                    </a>
                    <div class="bg-img-box">
                        <site-img :src="prevAndNext.prevImg" class="bg-img" />
                    </div>
                </template>
            </div>
            <div
                class="extral-banner-right"
                v-if="prevAndNext.show && !showFixedBanner && !isMobileSize"
            >
                <template v-if="prevAndNext.canNext">
                    <a
                        class="btn"
                        :href="prevAndNext.nextHref || null"
                        self="true"
                        rel="noopener noreferrer"
                    >
                        <span class="text">{{
                            $t('md-detail-info.next')
                        }}</span>
                        <span class="iconfont icon-next-big next"></span>
                    </a>
                    <div class="bg-img-box">
                        <site-img :src="prevAndNext.nextImg" class="bg-img" />
                    </div>
                </template>
            </div>
            <div
                class="detail-info-right"
                ref="right"
                :class="{ sold: info.listingStatus == 'Sold' }"
            >
                <Schedule
                    v-if="info.listingStatus != 'Sold'"
                    ref="schedule"
                    :additionalTitle="additionalTitle"
                    :extData="extData"
                    :apptTitle="apptTitle"
                    :apptSubTitle="apptSubTitle"
                    :apptSubmitText="apptSubmitText"
                    :apptQuestionMsg="apptQuestionMsg"
                />
                <GetMoreInfo v-else />
            </div>
            <DetailInfo
                ref="container"
                class="detail-info-left"
                :isapp="false"
                :positionProvided="positionProvided"
                @readMore="onScroll()"
            />
        </module-box>
        <module-box>
            <MLS :provided="positionProvided === PROVIDED_POSITION_KEY.under && 'standard'"/>
        </module-box>
        <BottomMenu
            v-if="isMobileSize"
            ref="mobileBottomMenu"
            theme="standard"
            :isOffer="showMakeOffer"
        />
        <house-mask v-if="isShowMask" theme="standard" />
        <schema-info :info="seoSchema" v-if="seoSchema" />
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import Common from '../index';
import Schedule from '../schedule.vue';
import DetailInfo from './detail-info.vue';
import global from '../../../common/global';
import DetailBanner from './banner.vue';
import BottomMenu from '../bottom-menu.vue';
import GetMoreInfo from './get-more-info.vue';
import MLS from '../mls.vue';
import HouseMask from '../mask.vue';

export default {
    components: {
        Schedule,
        DetailInfo,
        DetailBanner,
        BottomMenu,
        GetMoreInfo,
        MLS,
        HouseMask
    },
    provide() {
        return {
            sharePop: this.sharePop
        };
    },
    mixins: [Common],
    data: function() {
        return {
            leaveMsgTheme: 'standard',
            additionalTitle: null,
            showFixedBanner: false,
            theme: 'standard',
            styleTheme: 'standard'
        };
    },
    computed: {
        ...mapState({
            prevAndNext: 'prevAndNext'
        }),

        _baseTheme() {
            return 'standard';
        }
    },
    mounted() {
        this.headerHeight = 0;
        this.$root.moduleData.forEach(module => {
            if (module.name == 'md-header' && module.data.sticky) {
                let header = document.querySelector('.md-header');
                this.headerHeight = header ? header.offsetHeight : 0;
            }
        });

        if (this.info.listingStatus == 'Sold') {
            this.offsetTop = 0; 
        } else {
            this.offsetTop = 100; 
        }
        global.scroll(this.onScroll);
    },
    unmounted() {
        global.scroll(this.onScroll, true);
    },
    methods: {
        showFixedBannerChange(v) {
            this.showFixedBanner = v;
        },
        scrollIntoSchedule() {
            if (this.$refs.schedule) {
                this.$refs.schedule.$el.scrollIntoView();
            }
        },
        onScroll() {
            let right = this.$refs.right;
            if (this.$refs.container.$el.offsetHeight <= right.offsetHeight) {
                if (this.status == 'unactive') {
                    return;
                }
                right.style.position = 'static';
                this.status = 'unactive';
                return;
            }
            let containerRect =
                this.$refs.container.$el.getBoundingClientRect();
            let rightRect = right.getBoundingClientRect();

            if (containerRect.top > this.headerHeight + this.offsetTop) {
                if (this.status == 'normal') {
                    return; 
                }
                right.style.position = 'static';
                this.status = 'normal';
                return;
            }
            if (containerRect.top <= this.headerHeight + this.offsetTop) {
                if (
                    containerRect.bottom >
                    this.headerHeight + right.offsetHeight + this.offsetTop
                ) {
                    if (this.status == 'fixed') {
                        return; 
                    }
                    right.style.position = 'fixed';
                    right.style.left = rightRect.left + 'px';
                    right.style.top = this.headerHeight + this.offsetTop + 'px';
                    right.style.bottom = '';
                    right.style.zIndex = 100;
                    this.status = 'fixed';
                } else {
                    if (this.status == 'bottom') {
                        return; 
                    }
                    right.style.position = 'absolute';
                    right.style.right = '0px';
                    right.style.left = '';
                    right.style.bottom = '0px';
                    right.style.top = 'auto';
                    this.status = 'bottom';
                }
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';

$right-width: 340px;
.md-detail-info.standard {
    position: relative;
    .mg-container:not(.breadcrumb-bar) {
        position: relative;
        overflow: visible;
        &:after {
            content: '';
            display: block;
            clear: both;
        }
    }
    .detail-info-right {
        float: right;
        width: $right-width;
        &.sold {
            margin-top: 0px;
        }
        .fixed {
            position: fixed;
            width: $right-width;
        }
        .absolute {
            position: absolute;
            width: $right-width;
        }
    }
    .detail-info-left {
        float: left;
        width: calc(100% - #{$right-width});
        padding-right: 40px;
    }
    .mg-container {
        .extral-banner-right {
            right: 100px;
            top: -45px !important;
            transform: translateX(100%);
            padding-left: 20px;
        }
        .extral-banner-left {
            left: 100px;
            top: -45px !important;
            transform: translateX(-100%);
            padding-right: 20px;
            @media screen and (max-width: 1440px) {
                
            }
        }
        .extral-banner-right,
        .extral-banner-left {
            position: absolute;
            top: 10px;
            width: 100px;
            height: 60px;
            @media screen and (max-width: 1230px) {
                display: none;
            }
            .bg-img-box {
                opacity: 0;
                position: relative;
                &:after {
                    content: '';
                    position: absolute;
                    width: 80px;
                    height: 60px;
                    top: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0.1);
                }
                .bg-img {
                    width: 80px;
                    height: 60px;
                    display: inline-block;
                }
            }
            .btn {
                color: #515666;
                position: absolute;
                height: 25px;
                width: 80px;
                border-radius: 2px;
                border: solid 1px #515666;
                text-align: center;
                font-size: 14px;
                font-family: var(--font-bold);
                line-height: 23px;
                top: 50%;
                transform: translateY(-50%);
                z-index: 10;
                display: block;
                &:hover {
                    cursor: pointer;
                    border: none;
                    color: #ffffff;
                    line-height: 25px;
                    + .bg-img-box {
                        opacity: 1;
                    }
                }
                .iconfont {
                    font-size: 12px;
                    &.prev {
                        transform: rotate(180deg);
                        display: inline-block;
                    }
                }
            }
        }
    }
    @include media-800 {
        margin-top: 0px;
        .detail-info-right {
            display: none;
        }
        .detail-info-left {
            width: 100%;
            padding-right: 0px;
        }
    }
}
</style>
